// track-views.js

// Function to update product view count in local storage
function updateProductViewCount(productId) {
  var viewedProducts = JSON.parse(localStorage.getItem('viewed_products')) || {};
  viewedProducts[productId] = (viewedProducts[productId] || 0) + 1;
  localStorage.setItem('viewed_products', JSON.stringify(viewedProducts));
}

// Function to get total product views from local storage
function getProductViews(productId) {
  var viewedProducts = JSON.parse(localStorage.getItem('viewed_products')) || {};
  return viewedProducts[productId] || 0;
}

// Trigger view count update when a product page is loaded
document.addEventListener('DOMContentLoaded', function() {
  var productId = '{{ product.id }}'; // This variable holds the product ID for the current product page
  updateProductViewCount(productId);
});
